import React, { useContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { Button, Form, Modal } from 'react-bootstrap';
import { v4 as uuid } from 'uuid';
import AppContext from 'context/Context';
import UserDropdownV2 from 'components/dropdowns/CustomerServices/UserDropdownV2';
import { post, patch } from 'services/bs-kpi-board/kpiBoardService';
// import SmSectionDropdown from 'components/Dropdowns/SkillMatrix/SmSectionDropdown';
// import { patch } from 'services/skill-matric-services/smAreaService';

const KpiModal = ({ data, isShow, handleClose, handleSubmit }) => {
  const {
    config: { isDark }
  } = useContext(AppContext);

  useEffect(() => {
    setFormData(data);
  }, [data]);
  const [formData, setFormData] = useState(data);

  const handleDropdown = (field, value) => {
    console.log(field, value);
    const rs = { ...formData, [field]: value.userId };
    console.log(rs);
    setFormData({ ...formData, [field]: value.userId });
  };

  const handleChange = ({ target }) => {
    let name = target.name;
    let value = target.value;
    setFormData({ ...formData, [name]: value });
  };

  const onSubmit = async e => {
    console.log('submit');
    e.preventDefault();

    if (formData.id > 0) {
      await patch(formData.id, { ...formData });
    } else {
      await post({ id: uuid(), ...formData });
    }
    handleSubmit();
  };

  useEffect(() => {}, []);

  return (
    <Modal show={isShow} onHide={handleClose} contentClassName="border">
      <Form onSubmit={onSubmit}>
        <Modal.Header
          closeButton
          closeVariant={isDark ? 'white' : undefined}
          className="bg-light px-card border-bottom-0"
        >
          <Modal.Title as="h5">
            {formData.id > 0 ? 'Edit' : 'Create'} KPI
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-card">
          <Form.Group className="mb-3" controlId="titleInput">
            <Form.Label className="fs-0">Name</Form.Label>
            <Form.Control
              type="text"
              name="name"
              required
              value={formData?.name}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="description">
            <Form.Label className="fs-0">Description</Form.Label>
            <Form.Control
              type="text"
              name="description"
              required
              value={formData?.description}
              onChange={handleChange}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="inChargeUserId">
            <Form.Label className="fs-0">InCharge User</Form.Label>
            <UserDropdownV2
              fieldName="inChargeUserId"
              handleChange={handleDropdown}
              placeholder="InCharge User"
              value={formData?.inChargeUserId}
              isMulti={false}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="bg-light px-card border-top-0">
          <Button
            variant="primary"
            type="submit"
            onClick={onsubmit}
            className="px-4 mx-0"
          >
            Save
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

KpiModal.propTypes = {
  id: PropTypes.number,
  isShow: PropTypes.bool,
  handleClose: PropTypes.func,
  data: PropTypes.object,
  handleSubmit: PropTypes.func,
  name: PropTypes.string
};

export default KpiModal;
